export const hexToRgb = (hex, opacity) => {
    // 去除可能存在的 # 符号
    hex = hex.replace(/^#/, '');
    // 如果颜色值是缩写形式（例如 "#abc"），则将其扩展为完整形式（例如 "#aabbcc"）
    if (hex.length === 3) {
        hex = hex
            .split('')
            .map((char) => char + char)
            .join('');
    }
    // 从 16 进制转换为 10 进制
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    // 返回 RGB 值
    return opacity ? `rgba(${r}, ${g}, ${b}, ${opacity})` : `rgb(${r}, ${g}, ${b})`;
};
export const setStyle = (el, styleObject) => {
    for (let prop in styleObject) {
        el.style[prop] = styleObject[prop];
    }
};
export const createElement = (tag) => {
    return document.createElement(tag);
};
export const addEventListener = (el, event, fn) => {
    el.addEventListener(event, fn);
    return () => {
        el.removeEventListener(event, fn);
    };
};
//# sourceMappingURL=utils.js.map